import { useContext } from "react";
import ApprovalContext from "../contexts/approval-context";

export const useApproval = () => useContext(ApprovalContext);
